import { SidebarCollapseReducer, SidebarCollapseState } from "../types/temp-types";

type SidebarCollapseRematchModel = {
  state: SidebarCollapseState;
  reducers: SidebarCollapseReducer;
}

const sidebarCollapse: SidebarCollapseRematchModel = {
  state: {
    isCollapsed: false
  },
  reducers: {
    toggle: (state: SidebarCollapseState): SidebarCollapseState => {
      return { ...state, isCollapsed: !state.isCollapsed };
    },
    setCollapsed: (state: SidebarCollapseState, payload: boolean): SidebarCollapseState => {
      return { ...state, isCollapsed: payload };
    }
  }
};

export default sidebarCollapse;
